import { render, staticRenderFns } from "./videoxqPartner.vue?vue&type=template&id=02809cea&scoped=true"
import script from "./videoxqPartner.vue?vue&type=script&lang=js"
export * from "./videoxqPartner.vue?vue&type=script&lang=js"
import style0 from "./videoxqPartner.vue?vue&type=style&index=0&id=02809cea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02809cea",
  null
  
)

export default component.exports